import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { catchError, map, of, switchMap, withLatestFrom } from 'rxjs';
import { AppType } from 'src/app/model/app-type.model';
import { environment } from '../../environments/environment';
import AppError from '../../model/app-error';
import { ApiService } from '../../services/api.service';
import { AppState } from '../index';
import * as fromProcess from '../process/process.reducer';
import agreementsActions from './agreements.actions';

@Injectable()
export class AgreementsEffects {
  fetchStart$ = createEffect(() =>
    this.actions$.pipe(
      ofType(agreementsActions.fetchStart),
      withLatestFrom(this.store.select(fromProcess.selectProcessKind)),
      switchMap(([_, kind]) => {
        switch (environment.app) {
          case AppType.Direct:
            return kind
              ? this.apiService.getAgreements(kind).pipe(
                  map((data) => agreementsActions.fetchSuccess({ data })),
                  catchError((error: AppError) => of(agreementsActions.fetchError({ error }))),
                )
              : of(agreementsActions.fetchError({ error: new AppError('app', null, '') }));
          default:
            return kind
              ? this.apiService.getAgentAgreements(kind).pipe(
                  map((data) => agreementsActions.fetchSuccess({ data })),
                  catchError((error: AppError) => {
                    if (error.type === 'auth' || this.router.url === '/error/auth') {
                      void this.router.navigate(['/error/auth']);
                    }

                    return of(agreementsActions.fetchError({ error }));
                  }),
                )
              : of(agreementsActions.fetchError({ error: null }));
        }
      }),
    ),
  );

  constructor(private apiService: ApiService, private actions$: Actions, private store: Store<AppState>, private router: Router) {}
}
